
import React, { useState } from "react";
import { Button, Dropdown } from "react-bootstrap";
import { FiPlus, FiUpload } from "react-icons/fi";

import { FiFileText } from "react-icons/fi";
import { FaFilePdf, FaFileExcel } from "react-icons/fa";

import { RiHome6Line } from "react-icons/ri";
import { MdKeyboardArrowRight } from "react-icons/md";
import { Link } from "react-router-dom";
import { Breadcrumb, Col } from 'react-bootstrap';

export default function ResumeParsingHeader() {


  return (
    <div >

      {/* HEADER */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          flexWrap: "wrap",
          marginBottom: 20,
          alignItems:"center",
        }}
      >
 
   <Col md={4} sm={12}>
                  <div className="my-auto mb-2">
                    <h4 style={{ fontWeight: "600", marginBottom: "5px" }}>Resume Parsing</h4>
        
                    <Breadcrumb
                      style={{
                        background: "transparent",
                        padding: 0,
                        margin: 0,
                        fontSize: "14px",
                      }}
                    >
                      <Breadcrumb.Item>
                      <Link  to="/" >
               
                        <RiHome6Line
                          className="m text-dark"
                          style={{
                            fontSize: "1.2rem", // increased icon size
                            verticalAlign: "middle",
                                                     }}
                        /></Link>
                      </Breadcrumb.Item>
        
                      <MdKeyboardArrowRight className="mt-1 fs-5" />
        
                      <Breadcrumb.Item
                        linkAs="span"
                        className="text-dark text-decoration-none fs-6"
                      >
                      Training
                      </Breadcrumb.Item>
        
                      <MdKeyboardArrowRight className="mt-1 fs-5" />
        
                      <Breadcrumb.Item active>
                        <span className="text-dark fs-6">Learning Analytics</span>
                      </Breadcrumb.Item>
                    </Breadcrumb>
                  </div>
                </Col>


<div>
       <Dropdown>
      {/* BUTTON */}
      <Dropdown.Toggle
        style={{
          background: "#fff",
          border: "1px solid #e5e7eb",
          borderRadius: 8,
          padding: "6px 12px",
          fontSize: 14,
          display: "flex",
          alignItems: "center",
          gap: 6,
          color: "#111",
        }}
      >
        <FiFileText size={16} />
        Export
      </Dropdown.Toggle>

      {/* MENU */}
      <Dropdown.Menu
        style={{
          borderRadius: 10,
          padding: "10px 0",
          minWidth: 200,
          boxShadow: "0 10px 25px rgba(0,0,0,0.08)",
          border: "1px solid #eee",
        }}
      >
        {/* PDF */}
        <Dropdown.Item
          style={itemStyle}
          onClick={() => alert("Export PDF")}
        >
          <FaFilePdf style={{ color: "#ef4444" }} />
          Export as PDF
        </Dropdown.Item>

        {/* EXCEL */}
        <Dropdown.Item
          style={itemStyle}
          onClick={() => alert("Export Excel")}
        >
          <FaFileExcel style={{ color: "#16a34a" }} />
          Export as Excel
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
</div>
  
      </div>

 
    </div>
  );
}
const itemStyle = {
  display: "flex",
  alignItems: "center",
  gap: 10,
  padding: "10px 15px",
  fontSize: 14,
};